import { FormFieldDatePicker } from 'Components/FormField/FormFieldDatePicker/FormFieldDatePicker';
import { UnansweredQuestionMarker } from 'Components/RequiresAttentionMarker/UnansweredQuestionMarker';
import { Text, TextProps } from 'Components/Text/Text';
import { iso8601ToJsDate } from 'Helpers/DateTimeUtils/DateTimeUtils';
import { IrqQuestionDate, IrqQuestionType } from 'Models/InherentRisk';

export interface QuestionDateProps {
    formFieldId: string;
    onAnswerChanged: (date: Date) => void;
    question: IrqQuestionDate;
    questionNumber: number;
    showUnansweredQuestionMarker: boolean;

    disabled?: boolean;
    questionTextVariant?: TextProps['variant'];
}

/**
 * Renders a question that requires the user to input a date.
 * Currently used only for the IRQ.
 */
export const QuestionDate = (props: QuestionDateProps) => {
    return (
        <>
            <Text variant={props.questionTextVariant ?? 'Text2'}>{`${props.questionNumber}. ${props.question.text}`}</Text>
            {props.showUnansweredQuestionMarker && <UnansweredQuestionMarker questionIsRequired questionType={IrqQuestionType.DATE} />}
            <FormFieldDatePicker selected={props.question.answer ? iso8601ToJsDate(props.question.answer) : undefined} handleChange={props.onAnswerChanged} dateFormat="MM/dd/yyyy" formFieldId={props.formFieldId} formFieldLabel="Answer" placeholder={'MM/DD/YYYY'} />
        </>
    );
};
